var _templateObject;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from 'react';
import styled from 'styled-components';
import { matchPath } from 'react-router-dom';
import { parseUrl } from 'query-string';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import TabsBase from '@material-ui/core/Tabs';
import { getColorBackgroundSelector } from '@signal/theme/selectors';
import renderIf from '@signal/utils/renderIf';
var Tabs = styled(TabsBase)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  height: 100%;\n  align-items: center;\n  background-color: ", ";\n\n  .MuiTabs-scroller,\n  .MuiTabs-flexContainer {\n    height: 100%;\n  }\n"])), getColorBackgroundSelector('paper'));
export default function Nav(props) {
  var children = props.children,
      exact = props.exact,
      location = props.location;
  var allPaths = isArray(children) ? React.Children.map(children, function (child) {
    return get(child, 'props.to');
  }) : [get(children, 'props.to')];
  var activeTabIndex = allPaths.findIndex(function (path) {
    // if path is populated, try to extract just the url portion
    // this ensures that if the link contains a search query
    // it is ignored for the purposes of route matching.
    if (path) {
      path = parseUrl(path).url;
    }

    return matchPath(location.pathname, {
      exact: exact,
      path: path
    });
  }); // prevent "-1" from being passed to the Tabs component

  if (activeTabIndex < 0) {
    activeTabIndex = 0;
  }

  return /*#__PURE__*/React.createElement(Tabs, {
    variant: "fullWidth",
    value: activeTabIndex,
    indicatorColor: "primary",
    textColor: "primary"
  }, React.Children.map(children, function (child, i) {
    return renderIf(child, function () {
      return /*#__PURE__*/React.cloneElement(child, {
        active: i === activeTabIndex
      });
    });
  }));
}